import React, { useState } from "react";
import { IconModal } from "../../IconModal";

import { Container, Items } from "./styles";

function Resume({ items }) {
  return (
    <Items>
      {items.map((item) => (
        <li key={item.label}>
          {item.items ? <strong>{item.label}</strong> : <p>{item.label}</p>}

          {item.items && <Resume items={item.items} />}
        </li>
      ))}
    </Items>
  );
}

function ResumeCustomer({ customer }) {
  const [open, setOpen] = useState(false);

  return (
    <Container>
      <IconModal
        title="Por que eu recebi esse lead?"
        handleOpenModal={() => {}}
        open={open}
        setOpen={setOpen}
        icon={
          <strong style={{ color: "#000", fontSize: 16 }}>
            Por que eu recebi esse lead?
          </strong>
        }
      >
        <Resume items={customer.resume} />
      </IconModal>
    </Container>
  );
}

export default ResumeCustomer;
